import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import { withI18n } from '../../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';

const SelectedNightsLabel = ({
  i18n: { formatCurrencyFull, translate, translatePlural },
  numberOfNights,
  originalBasicPricePerNight,
}: {
  numberOfNights: number;
  i18n: I18nService;
  originalBasicPricePerNight: number;
}) => {
  const totalNumberOfNights = translatePlural(
    'SelectionSummary_label_nights',
    numberOfNights,
    'number',
  );

  return (
    <BpkText textStyle={TEXT_STYLES.label1}>
      {numberOfNights > 1
        ? translate('PriceBreakDown_PriceItem_PriceAndNights', {
            price: formatCurrencyFull(originalBasicPricePerNight),
            nights: totalNumberOfNights,
          })
        : totalNumberOfNights}
    </BpkText>
  );
};

export default withI18n(SelectedNightsLabel);
